<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="agpr-links agpr-contextMenu-parent" [formGroup]="userForm" role="group" aria-label="Links Block">
    <div class="agpr-links-box"  *ngIf="(dataSource.all() | async)?.length==0" (click)="onEdit()">
      <span class="agpr-links-boxLabel">
        <span class="fa-regular fa-duotone fa-link agpr-links-boxLabelIcon"></span>
        <span class="agpr-links-boxLabelText">Links</span>
      </span>
        <ul class="agpr-contextMenu top right" role="menu" aria-describedby="links_error">
            <li role="menuitem">
                <agpr-button
                    class="agpr-links-deleteButton"
                    icon="fa-regular fa-duotone fa-trash-can"
                    (click)="onDelete()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.delete'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    class="agpr-links-editButton"
                    icon="fa-regular fa-duotone fa-pen"
                    (click)="onEdit()"
                    [tooltip]="'PageBuilder.briefings.blockIcon.edit'"
                    [style]="buttonTypes.contextMenu"
                >
                </agpr-button>
            </li>
        </ul>
        <div class="agpr-links-emptyBox"></div>
    </div>
    <ul class="agpr-links-list">
      <li class="agpr-links-listItem" *ngFor="let item of dataSource.all() | async; index as iCount; let last = last;" >
          <div *ngIf="iCount<maxLinkItems">
              <div *ngIf="(textIndex>-1 && textIndex==iCount) then textMode else normalMode"></div>
              <ng-template #textMode>
                  <div>
                      <input type="text"
                          class="agpr-links-input"
                          #linkInput
                          formControlName="linktextUrl"
                          pInputText
                          [(ngModel)]="item.webAddress"
                          (ngModelChange)="onLinkTextInput()"
                          (blur)="onLinkInputBlur($event, item, iCount,linkInput.value.trim())"
                          aria-label="Link URL"
                      />
                      {{ linkInput.focus() }}
                  </div>
              </ng-template>
              <ng-template #normalMode>
                    <div
                        class="{{!isDisabled ?'agpr-links-listLink':'agpr-links-listLinkDisable'}} agpr-contextMenu-parent"
                        (click)="openLinkBlock(iCount);"
                    >
                      <div class="agpr-links-linkAnchor agpr-links-highLight">
                          {{item.webAddress}}
                      </div>
                      <span *ngIf="!isDisabled">
                        <ul role="menu" class="agpr-contextMenu top right" [attr.aria-label]="item.webAddress" aria-describedby="links_error">
                            <li role="menuitem">
                                <agpr-button
                                    icon="fa-regular fa-duotone fa-trash-can"
                                    (click)="delete(iCount)"
                                    tooltip="PageBuilder.briefings.blockIcon.delete"
                                    [style]="buttonTypes.contextMenu"
                                >
                                </agpr-button>
                            </li>
                            <li role="menuitem">
                                <agpr-button
                                    icon="fa-regular fa-duotone fa-pen"
                                    (click)="edit(iCount)"
                                    tooltip="PageBuilder.briefings.blockIcon.edit"
                                    [style]="buttonTypes.contextMenu"
                                >
                                </agpr-button>
                            </li>
                            <li role="menuitem" *ngIf="(iCount+1) < maxLinkItems && last && item.webAddress.length > 0">
                                <agpr-button
                                    icon="fa-regular fa-duotone fa-plus"
                                    (click)="add(item)"
                                    tooltip="PageBuilder.briefings.blockIcon.addBlock"
                                    [style]="buttonTypes.contextMenu"
                                >
                                </agpr-button>
                            </li>
                        </ul>
                      </span>
                  </div>
              </ng-template>
          </div>
      </li>
  </ul>
  <div *ngIf="textIndex>-1">
    <agpr-form-message *ngIf="textIndex>-1 && linktextUrl?.errors?.pattern" id="links_error">
        {{ linkFormatErrorMessage }}
    </agpr-form-message>
  </div>
</div>
